import { Box, Heading } from "@chakra-ui/react"

import {
  selectActiveToken,
  selectDepositAmount,
  selectLockTime,
  useDappSelector,
} from "#/redux-state"
import { calculateDailyMats, formatMats } from "#/shared/utils"

import MatsDisplayWidget from "../MatsDisplayWidget"

export default function AccountPanelMats() {
  const depositAmount = useDappSelector(selectDepositAmount)
  const { multiplier } = useDappSelector(selectLockTime)

  const activeToken = useDappSelector(selectActiveToken)

  const dailyMats = calculateDailyMats(depositAmount, multiplier, activeToken)

  const formattedDailyMats = formatMats(dailyMats)

  return (
    <Box>
      <Heading variant="h4" color="primary.black.60" mb={1}>
        You will get
      </Heading>
      <MatsDisplayWidget
        variant="red"
        size="xl"
        mats={Number(depositAmount) > 0 ? formattedDailyMats : 0}
        tooltipPlacement="left"
      />
    </Box>
  )
}
